import React from 'react';

import {Input, Label} from 'reactstrap';

const OrderRadio = ({isOrderAppended, selectOrder, label, id}) =>
    <Label className={isOrderAppended(id) ? "disabled" : ""} check>
        <Input type="radio" name="service" id={id} onChange={selectOrder} disabled={isOrderAppended(id)} />
        {label}
    </Label>

export default OrderRadio;


// WEBPACK FOOTER //
// ./src/app/components/OrderRadio.js